import { render, staticRenderFns } from "./my-ckhk.vue?vue&type=template&id=3bbe0a8c&scoped=true&"
import script from "./my-ckhk.vue?vue&type=script&lang=js&"
export * from "./my-ckhk.vue?vue&type=script&lang=js&"
import style0 from "./my-ckhk.vue?vue&type=style&index=0&id=3bbe0a8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe0a8c",
  null
  
)

export default component.exports